import { render } from "./BuscarClases.vue?vue&type=template&id=ef1a68cc"
import script from "./BuscarClases.vue?vue&type=script&lang=js"
export * from "./BuscarClases.vue?vue&type=script&lang=js"

import "./BuscarClases.vue?vue&type=style&index=0&id=ef1a68cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__